import { RouterProvider } from "react-router-dom";
import { Toaster } from "@/components/ui/sonner";
import { TooltipProvider } from "@/components/ui/tooltip";
import { router } from "@/router";

export default function App() {
  return (
    // One tooltip provider for the whole app. Radix's `Tooltip` needs one
    // above it and does not carry its own, so before this the sidebar mounted
    // a provider of its own and anything else that wanted a tooltip had to
    // remember to. Nesting is harmless, so the sidebar's still works.
    <TooltipProvider>
      <RouterProvider router={router} />
      <Toaster />
    </TooltipProvider>
  );
}
